import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const Reject = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const saveDocument = utils.hooks.useSaveDocument();
  const { checkDocuments } = useCheckBeforeAction(actionType.REJECT);
  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    if ((await saveDocument()) === null) {
      return;
    }

    const modalType = records.length === 1 ? actionType.REJECT : actionType.MULTIPLE_REJECT;

    dispatch(actions.modal.openModal(modalType));
  };
  return (
    <CommonButton
      id="reject-btn"
      action={onClick}
      scope="tertiary"
      value={t(actionType.REJECT)}
      disabled={!utils.user.isActionEnabled(records, actionType.REJECT)}
      customIcon="reject"
    />
  );
};

export default Reject;
